import React from 'react';
import { useIntl } from "react-intl";

interface FrameChromeProps {
 file?: string;
 visible?: boolean;
 height: any;
}

const FrameChrome = ({ file = "", visible = false, height }: FrameChromeProps) => {

  const iframeRef = React.createRef()

  if (file && visible) {
    return (
      <div
      style={{ width: "100%", height: "100%" }}>
      <iframe title="frame" ref={iframeRef as any} id='ifrm'
        src={file}
        style={{ width: '100%', height: '100%' }}
        onLoad={() => {
          if((iframeRef as any).current.contentDocument){
            var image = (iframeRef as any).current.contentDocument.getElementsByTagName('img')[0];

            if (!!image) {
              image.style.width = "100%";
              image.style.height = height ? height : "auto";
            }
          }
        }}
      >
      </iframe>
    </div>
    )
  } else {
    return <div></div>;
  }
};


export default React.memo(FrameChrome)